import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectClientLabels = (store: StoreSchema) => store.clientLabels.clientLabels